import { render } from "./ShowSpecific.vue?vue&type=template&id=03eb835c"
import script from "./ShowSpecific.vue?vue&type=script&lang=js"
export * from "./ShowSpecific.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__